var _Path, _Path2, _Path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 0 25 25",
    height: "1em",
    width: "1em",
    strokeWidth: 1.8
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M.5 19.5h20M.5 15.5h20M5.5 11.5v12M10.5 11.5v12M15.5 11.5v12M.5 11.5h20"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.5 3.5H.5v20h20v-20z",
    fill: "none"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M4.5 1.5v4M16.5 1.5v4"
  })));
}
export default SvgCalendar;